import { useState } from "react";
import { Link } from "react-router-dom";

function Footer() {
  const [nav, setNav] = useState(false);

  const openNav = () => {
    setNav(!nav);
  };
  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-content">
            <ul className="footer-content__1">
              <li>
                <span>MyDear</span>Cab
              </li>
              <li>
                MyDearCab offers reliable and comfortable cab services for all
                your transportation needs. We provide safe, affordable rides
                with professional drivers.
              </li>
              <li>
                <a href="tel:+917020065876">
                  <i className="fa-solid fa-phone"></i> &nbsp; +91 70200 65876
                </a>
              </li>

              <li>
                <a href="mailto:mydearcabs@gmail.com">
                  <i className="fa-solid fa-envelope"></i>
                  &nbsp; mydearcabs@gmail.com
                </a>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>Company</li>
              <li>
                <Link onClick={openNav} to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link onClick={openNav} to="/about">
                  About
                </Link>
              </li>
              <li>
                <Link onClick={openNav} to="/ourservices">
                  Our Services
                </Link>
              </li>
              <li>
                <Link onClick={openNav} to="/contact">
                  Contact
                </Link>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>Our Service</li>
              <li>
                <a href="https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab">
                  Pune to Mumbai
                </a>
              </li>
              <li>
                <a href="https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab">
                  Mumbai to Pune
                </a>
              </li>
              <li>
                <a href="https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab">
                  Pune to Mumbai Airport
                </a>
              </li>
              <li>
                <a href="https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab">
                  Mumbai Airport to Pune
                </a>
              </li>
              <li>
                <a href="https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab">
                  Pune to Mumbai
                </a>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>Contact Details</li>
              <li>
                <a href="tel:+918007722929">
                  <i className="fa-solid fa-phone"></i> &nbsp; +91 80077 22929
                </a>
              </li>
              <li>
                <a href="tel:+918600217396">
                  <i className="fa-solid fa-phone"></i> &nbsp; +91 86002 17396
                </a>
              </li>
              <li>
                <a href="tel:+919960184319">
                  <i className="fa-solid fa-phone"></i> &nbsp; +91 99601 84319
                </a>
              </li>
              <li>
                <a href="tel:+917020065876">
                  <i className="fa-solid fa-phone"></i> &nbsp; +91 70200 65876
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
